import store from '@/store'

const Login = () => import('@/components/login/Login');
const ForgotPassword = () => import('@/components/forgot-password/ForgotPassword');
const Home = () => import('@/components/home/Home');
const HomeLayout = () => import('@/components/home-layout/HomeLayout');
const ErrorsAndNotifications = () => import('@/components/errors-and-notifications/ErrorsAndNotifications');
const ChangePassword = () => import('@/components/change-password/ChangePassword');
const RipsDetail = () => import('@/components/rips/RipsDetail');
const Dashboard = () => import('@/components/dashboard/Dashboard');

const areUserPrerequisitesValid = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  return next()
}

const hasDashboardAccess = (to, from, next) => {

  if (!store.getters.isAuthenticated) {
    return next('/login')
  }

  if (!store.getters.tokenExtensions?.userDashboard) {
    return next(from)
  }

  return next()

}



const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    component: HomeLayout,
    beforeEnter: areUserPrerequisitesValid,
    redirect: { name: 'Home' },
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        beforeEnter: areUserPrerequisitesValid
      },
      {
        path: '/rips/:ripsId',
        name: 'RipsDetail',
        component: RipsDetail,
        beforeEnter: areUserPrerequisitesValid
      },
      {
        path: '/errors-and-notifications/:id',
        name: 'ErrorsAndNotifications',
        component: ErrorsAndNotifications,
        beforeEnter: areUserPrerequisitesValid
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter: hasDashboardAccess
      },
    ]
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
    props: (route) => ({ token: route.query.token }),
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '*',
    redirect: { name: 'Login' },
  }
]

export default routes;